import { Component, OnInit } from '@angular/core';
import { ServiceLayer } from '../../services/serviceLayer';
import { Observable } from 'rxjs';
import { DAO } from '../../modal/DAO';
import * as _ from 'lodash';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthService, User } from '@auth0/auth0-angular';
import { map} from 'rxjs/operators';
declare var require: any
let jsonPathRef = require('jsonpath');
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  public reason: any;
  public UnderWriterDetails: any;
  public bfmSupport: any;
  public policyQuoteList: any;
  public userDetailsFromAuth: Observable<User | null>;
  public isBFMInternal:boolean=false;
  public showMaintenanceMode: boolean=false;
  public DisablePage: boolean=false;
  public notification: any;
  constructor(public dao: DAO, private serviceLayer: ServiceLayer, public authenticationService: AuthenticationService,private auth: AuthService) { }

  async ngOnInit() {
    await this.checkLoginCredential();    
    await this.getUnderWriterInfo();
    // await this.getPolicyQuotesList();
    // await this.getreasons();
    //let response = JSON.parse(window.localStorage.getItem("policyReasons"));
    
    // if(response == undefined && response == null) {
    //   await this.getreasons();
    // }
    // else {
    //   let reasonDetails = jsonPathRef.query(response,"$..[?(@.key == 'cancelReasonCd')].questionOptions")[0];
    //   if(reasonDetails == undefined || reasonDetails.length==0) {
    //     await this.getreasons();
    //   }
    // }
  }

  async getPolicyQuotesList() {
    var policyQuotesList = await this.serviceLayer.getSearchPoliciesList('Policy');
    if(policyQuotesList != undefined && policyQuotesList != null && policyQuotesList.length>0) {
      var policyList = policyQuotesList.filter(s => s.typeName == 'Policy');
    }
    var WantToList = [
      { "label": "Report a claim", "value": "Report a claim", "disabled": false },
      { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
      { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
      { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
    ];
    if (policyList != undefined && policyList.length > 0) {
      policyList.forEach(policy => {
        policy['wantedTo'] = _.cloneDeep(WantToList);
        if (['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policy.status.toUpperCase())) {
          policy['wantedTo'][3].disabled = true;
        }
      });
    }
    window.localStorage.setItem("policyQuotesList", JSON.stringify(policyQuotesList));
  }

  async getreasons() {
    await this.serviceLayer.getCancelReasonDetails();
    // window.localStorage.setItem("policyQuotesList", JSON.stringify(policyQuotesList));
  }

  policy(policytype) {
    if (policytype != undefined && policytype == 'Cancel My Policy') {
      window.localStorage.setItem("policyType", "Cancel My Policy");
    }
    else if (policytype != undefined && policytype == 'Manage a Policy') {
      window.localStorage.setItem("policyType", "Manage a Policy");
    }
    window.localStorage.setItem("currentPolicy", "");
  }

  async getUnderWriterInfo() {
    var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
    this.UnderWriterDetails = await this.serviceLayer.getUnderWriterInformation();
    if (this.UnderWriterDetails?.bfmSupportInformation != undefined && this.UnderWriterDetails?.bfmSupportInformation.length > 0) {
      window.localStorage.setItem("UnderWriterInfo", JSON.stringify(this.UnderWriterDetails));
      if(loginDetails?.isinternal && (loginDetails?.email).includes("@berkleymarine.com")){
        this.isBFMInternal = loginDetails?.isinternal;
      }
      this.bfmSupport = this.UnderWriterDetails?.bfmSupportInformation[0];
      if (this.bfmSupport.length > 0) {
        this.bfmSupport = this.bfmSupport[0];
      }
    }
  }
  async checkLoginCredential() {
    // this.jwt$ = this.authenticationService.jwt$;
    this.auth.isAuthenticated$.pipe(
      // take(1), // Take only the first emitted value and complete the observable
      map(loggedIn => {
        if (!loggedIn) {
          this.authenticationService.login();
          return true;
        }
        return true;
      })
    );
    this.userDetailsFromAuth = this.authenticationService.user$;
    if ((location.href.split("#") && location.href.split("#").length > 1 && location.href.split("#")[1].split("&").some(data => data.startsWith('error_description')))) {
      // Commented out this condition for Ticket 349: removed metadata company check from login validation
      //(this.dao.loginUserDetail && this.dao.loginUserDetail.userCompanyGroup && this.dao.loginUserDetail.userCompanyGroup === 'Others')) 
      window.location.href = "/xps/unauthenticated";
    }
    else if(this.dao.loginUserDetail?.isInternal == false && this.dao.loginUserDetail?.agencies == ""){
      window.location.href = "/xps/unauthenticated";
    }
    //==============assigne login user details from Auth call==============
    if (!this.dao.loginUserDetail || this.dao.loginUserDetail.isVerifiedSITAuth === undefined) {
      this.saveUserDetails(this.dao.loginUserDetail);
    }
  }
  async saveUserDetails(userData) {
    if (userData && userData.email) {
      await this.serviceLayer.getExternalDetails(userData);
    }
  }

}
